import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import config from './config';
import { isDevelopment } from './utils/env';

// Version check
console.log('Firebase Module Version: 2.0.0 - Production Mode');

// Initialize Firebase
let db: any = null;

// Only initialize Firebase if we have valid configuration
console.log('Checking Firebase configuration:', {
  hasApiKey: !!config.firebase.apiKey,
  hasProjectId: !!config.firebase.projectId,
  hasAppId: !!config.firebase.appId,
  environment: isDevelopment() ? 'Development' : 'Production',
  collectionName: config.app.resultsCollection,
  storageType: config.app.storage.type,
  forceType: config.app.storage.forceType
});

// In development, we can be more lenient with Firebase initialization
const shouldInitializeFirebase = () => {
  if (isDevelopment()) {
    // In development, initialize if we have the minimum required config
    const hasMinConfig = config.firebase.apiKey && config.firebase.projectId;
    console.log('Development mode: Checking minimum Firebase config:', {
      hasApiKey: !!config.firebase.apiKey,
      hasProjectId: !!config.firebase.projectId,
      hasMinConfig
    });
    return hasMinConfig;
  }
  
  // In production, require all config
  const hasFullConfig = config.firebase.apiKey && config.firebase.projectId && config.firebase.appId;
  console.log('Production mode: Checking full Firebase config:', {
    hasApiKey: !!config.firebase.apiKey,
    hasProjectId: !!config.firebase.projectId,
    hasAppId: !!config.firebase.appId,
    hasFullConfig
  });
  return hasFullConfig;
};

if (shouldInitializeFirebase()) {
  db = getFirestore(initializeApp(config.firebase));
} else {
  const error = 'Firebase configuration is missing';
  console.error(error);
  if (!isDevelopment()) {
    throw new Error(error);
  }
  console.warn('Development mode: Continuing without Firebase');
  db = null;
}

// Helper function to check if we should use localStorage
export const shouldUseLocalStorage = () => {
  // Check if we have a forced storage type
  if (config.app.storage.forceType) {
    const useLocalStorage = config.app.storage.forceType === 'localStorage';
    console.log(`Using forced storage type: ${config.app.storage.forceType}`);
    return useLocalStorage;
  }

  // Check if we have a specific storage type set
  if (config.app.storage.type !== 'auto') {
    const useLocalStorage = config.app.storage.type === 'localStorage';
    console.log(`Using configured storage type: ${config.app.storage.type}`);
    return useLocalStorage;
  }

  // Auto mode: use localStorage in dev, firestore in prod
  const useLocalStorage = isDevelopment();
  console.log(`Auto mode: Using ${useLocalStorage ? 'localStorage' : 'Firestore'} (${isDevelopment() ? 'Development' : 'Production'} mode)`);
  return useLocalStorage;
};

// Helper function to get Firestore instance
export const getDb = () => {
  return db;
};

export { db }; 